<template>
  <div class="set-pdf">
    <div class="row">
      <div class="row-title">选择打印数据</div>
      <tree-select
        :group-list="workflowVarGroupRef"
        v-model="data.dataId"
        @change="changeExtra('data')"
        class="mTop10"
      ></tree-select>
    </div>
    <div class="row">
      <div class="row-title">选择打印模板</div>
      <normal-select
        class="mTop10"
        size="normal"
        :selectList="templateList"
        :selectedItem.sync="data.templateId"
        @update:selectedItem="changeExtra('template')"
      ></normal-select>
    </div>
  </div>
</template>

<script>
import TreeSelect from "@/components/UIComponents/TreeSelect"
import { filterTreeVarGroup } from "@/utils/workFlow"
import { getList } from "@/api/appManage/print-template"
import NormalSelect from "@/components/UIComponents/NormalSelect"
import { bfs } from "@/utils/algorithm"

export default {
  name: "set-pdf",
  components: { NormalSelect, TreeSelect },
  props: {
    data: Object,
    extra: Object,
    workflowVarGroup: Array
  },
  data() {
    return {
      sheetId: "",
      templateList: []
    }
  },
  computed: {
    workflowVarGroupRef() {
      return filterTreeVarGroup({
        varGroup: this.workflowVarGroup,
        filterFunc: option => option.control?._type === "ref" && option.control?.oneFlag
      })
    },
    workFlowValueMap() {
      let map = {}
      bfs({
        arr: this.workflowVarGroupRef,
        childFuc: group => group.children,
        cbk: group => {
          group.options.forEach(option => (map[option.value] = option))
        }
      })
      return map
    }
  },
  watch: {
    sheetId: {
      immediate: true,
      handler() {
        if (this.sheetId) {
          getList({ type: "sheetId", id: this.sheetId }).then(
            res => (this.templateList = res.map(item => ({ label: item.name, value: item.id })))
          )
        }
      }
    }
  },
  created() {
    this.sheetId = this.workFlowValueMap[this.data.dataId]?.control?.refSheetId
  },
  methods: {
    changeExtra(from) {
      if (from === "data") {
        this.data.templateId = ""
      }
      this.sheetId = this.workFlowValueMap[this.data.dataId]?.control?.refSheetId
      let printData = this.workFlowValueMap[this.data.dataId]?.label
      let printTemplate = this.templateList.find(
        template => template.value === this.data.templateId
      )?.label
      this.$set(this.extra, "description", { printData: printData, printTemplate: printTemplate })
    }
  }
}
</script>

<style lang="scss" scoped>
.set-pdf {
  .row {
    font-size: 13px;
    padding-bottom: 15px;
    .row-title {
      font-weight: bold;
    }
    .row-tip {
      color: #9e9e9e;
    }
    .row-body {
      margin-top: 10px;
    }
  }
}
</style>
